import axios from 'axios';

export function createAdvertiserCategory(name, token) {
    return axios.post(process.env.REACT_APP_API_URL + `/advertiserCategory`, { name }, {
        headers: {
            Authorization: `${token}`
        }
    });
}
